<template>
  <aside v-if="menuActive">
    <div class="opacity"></div>
    <div class="menu" v-click-outside="toggleMenu">
      <a href="#" v-on:click.prevent="toggleMenu" class="pull-right"><img src="../assets/img/icon-close.svg" alt=""></a>
      <ul class="list-unstyled">
        <li v-if="globals.acl.Patients.insertAction == 1"><router-link v-bind:class="active('Patients')" to="/patients" v-on:click.native.prevent="toggleMenu">{{$t('PACIENTS')}}</router-link></li>
        <li v-if="globals.acl.Patients.insertAction == 1"><router-link v-bind:class="active('Tasks')" to="/profile/tasks" v-on:click.native.prevent="toggleMenu">{{$t('PROFILE')}}</router-link></li>
        <li v-if="globals.acl.Patients.insertAction == 0 && globals.acl.DentalSolutions.instantiate == 1"><router-link v-bind:class="active('Tasks')" to="/profile/chat" v-on:click.native.prevent="toggleMenu">{{$t('PROFILE')}}</router-link></li>
        <li class="d-none d-md-block" v-if="globals.acl.User.insertAction == 1"><router-link v-bind:class="active('Employees')" to="/employees" v-on:click.native.prevent="toggleMenu">{{$t('WORKERS')}}</router-link></li>
        <li class="d-none d-md-block" v-if="globals.acl.Protetics.insertAction == 1"><router-link v-bind:class="active('Protetics')" to="/protetics" v-on:click.native.prevent="toggleMenu">{{$t('PRODUCTS')}}</router-link></li>
        <li class="d-none d-md-block" v-if="globals.acl.User_companies.updateAction == 1"><router-link v-bind:class="active('ControlPanel')" to="/controlpanel/basic" v-on:click.native.prevent="toggleMenu">{{$t('CONTROLPANEL')}}</router-link></li>
        <li class="d-none d-md-block" v-if="globals.acl.Reports.instantiate == 1"><router-link v-bind:class="active('Reports')" to="/reports" v-on:click.native.prevent="toggleMenu">{{$t('REPORTS')}}</router-link></li>
        <!-- li class="d-none d-md-block" v-if="globals.acl.DentalSolutions.instantiate == 1"><router-link v-bind:class="active('DentalSolutions')" to="/dentalsolutions" v-on:click.native.prevent="toggleMenu">{{$t('DENTALSOLUTIONS')}}</router-link></li>
        <li class="d-none d-md-block" v-if="globals.acl.DentalSolutions.instantiate == 1"><router-link v-bind:class="active('ReportsDs')" to="/reportsds/client" v-on:click.native.prevent="toggleMenu">{{$t('DSREPORTS')}}</router-link></li -->
        <li><a href="#" v-on:click.prevent="logout">{{$t('LOGOUT')}} <img src="../assets/img/icon-log-out.svg" alt=""></a></li>
      </ul>
      <div class="form-group">
        <label>{{ $t('LANGUAGE') }}</label>
        <select v-model="globals.langCode" class="form-control secondary" @change="setLanguage">
          <option v-for="lang in globals.languages" :key="lang.langCode" :value="lang.langCode">{{ $t(lang.langName) }}</option>
        </select>
      </div>
    </div>
  </aside>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Header',
  computed:
  {
    ...mapGetters([
      'globals',
      'menuActive'
    ])
  },
  methods:
  {
    ...mapActions([
      'logout',
      'fetchLanguage'
    ]),
    toggleMenu: function ()
    {
      var me = this;
      me.$store.commit('toggleMenu')
    },
    active: function(route)
    {
      if(this.$route.name == route) return 'active';
      return '';
    },
    setLanguage()
    {
      var me = this;
      var selectedLang = me.globals.langCode;
      me.fetchLanguage(selectedLang);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue